import React, { Component } from 'react';
import styled from 'styled-components';
import { getTheme } from '../../global/utils';

const LegendWrapper = styled.div`
  legend {
    text-transform: uppercase;
    font-weight: 700;
    font-size: ${props =>
      (props.size === 'xsmall' && getTheme('fontSize', 'caption')) ||
      (props.size === 'small' && getTheme('fontSize', 'note')) ||
      (props.size === 'medium' && getTheme('fontSize', 'body')) ||
      (props.size === 'large' && getTheme('fontSize', 'title')) ||
      getTheme('fontSize', 'body')};

    margin-bottom: ${props =>
      (props.size === 'xsmall' && getTheme('marginBottom', 's')) ||
      (props.size === 'small' && getTheme('marginBottom', 'm')) ||
      (props.size === 'medium' && getTheme('marginBottom', 'l')) ||
      (props.size === 'large' && getTheme('marginBottom', 'xl')) ||
      getTheme('fontSize', 'body')};

    &::before {
      content: '';
      display: block;
      width: 32px;
      height: 4px;
      background-color: ${getTheme('secondary', '_600')};
      margin-bottom: ${getTheme('padding', 'verticalM')};
    }
  }
`;

class Legend extends Component {
  render() {
    return (
      <LegendWrapper size={this.props.size}>
        <legend className={this.props.className}>{this.props.children}</legend>
      </LegendWrapper>
    );
  }
}

export default Legend;



// WEBPACK FOOTER //
// ./src/components/forms/Legend.js